import {useQuery} from '@tanstack/react-query';
import {refreshSessionAccess} from '../api';
import {useSession} from '../session';

/** Refresh assigned workspaces at their entry, without blocking the page. */
export function useWorkspaceAccessRefresh(enabled:boolean){
  const token=useSession(s=>s.session?.accessToken);
  useQuery({
    queryKey:['workspace-access',token],
    queryFn:async()=>{await refreshSessionAccess();return true;},
    enabled:enabled&&Boolean(token),staleTime:0,retry:false,
    refetchOnMount:'always',refetchOnWindowFocus:true,
  });
}
